/* eslint-disable jsx-a11y/alt-text */
import ImgFailed from 'assets/img/icons/failed_icon.svg';
import ImgSuccess from 'assets/img/success_img.png';
import { Hooks } from 'providers';
import {
  useContext, useEffect, useRef, useState,
} from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { HIT_BOARD_STATUS } from 'redux/actions/board';
import MessageTable from 'components/_parts/molecules/messageTable';
import Label from 'components/_parts/atoms/label';
import { useOuterClick } from 'providers/OutsideClick';
import ButtonCustom from 'components/_parts/atoms/button';
import ListError from './ListError';

function PopUp() {
  const dispatch = useDispatch();
  const { modal: modalImport, setModal: setModalImport } = useContext(Hooks);
  const {
    status, message, listView, tableMessage, button,
  } = useSelector(
    (state) => ({
      status: state.board.status,
      message: state.board.message,
      tableMessage: state?.board?.tempData,
      listView: state.board.listView,
      button: state.board.button,
    }),
  );

  const myRef = useOuterClick((e) => {
    if (e.target.id === 'successModal_regis') {
      setModal(false);
      dispatch({
        type: HIT_BOARD_STATUS,
        payload: {
          status: '',
          message: '',
          listView: '',
        },
      });
    }
  });

  const { setModal, modal } = useContext(Hooks);
  const [switch_, setSwitch] = useState(false);
  useEffect(() => {
    if (status === 'success' || status === 'failed') {
      setModal(true);
      setSwitch(true);
    }
  }, [status]);
  if (listView === 'listView') {
    return createPortal(
      <div
        className={`modal fade rModal tw ${
          (status === 'success' || status === 'failed')
          && 'show !tw-flex !tw-content-center !tw-items-center'
        } `}
        id="successModal_regis"
        tabIndex="-1"
        role="dialog"
        aria-hidden="false"
      >
        <div
          ref={myRef}
          className="modal-dialog modal-sm !tw-max-h-[659px] !tw-max-w-[623px] !tw-top-0 !tw-w-full !tw-h-full"
          role="document"
        >
          <div
            className="modal-content !tw-h-full"
            style={{ borderRadius: '20px' }}
          >
            <div className="modal-header !tw-flex !tw-px-[40px] !tw-pt-[28px] !tw-pb-[0px]">
              <div className="tw-flex tw-flex-col !tw-max-w-[380px]">
                <h4 className="!tw-font-[700]">
                  <b>You have Error on your previous upload</b>
                </h4>
                <p className="!tw-text-[12px] !tw-text-left">
                  Please check this upload result to see where you need to fix
                  your data first before uploading the data.
                </p>
              </div>
              <div>
                <ButtonCustom
                  className="!tw-p-[12px] !tw-w-[125px] !tw-flex !tw-justify-center tw-items-center"
                  func={() => {
                    setModalImport({
                      type: 'import-choose',
                      status: true,
                    });
                    dispatch({
                      type: HIT_BOARD_STATUS,
                      payload: {
                        status: '',
                        message: '',
                        listView: '',
                      },
                    });
                  }}
                >
                  {' '}
                  Re-Upload
                </ButtonCustom>
              </div>
            </div>
            <div className="modal-body !tw-flex !tw-flex-col !tw-p-[0px]">
              {/* <ListError /> */}
              <MessageTable data={tableMessage} message={message} />
            </div>
          </div>
        </div>
      </div>,
      document.getElementById('portal'),
    );
  }

  return (
    <>
      {createPortal(
        <div
          className={`modal fade rModal tw ${
            (status === 'success' || status === 'failed')
            && 'show !tw-flex !tw-content-center !tw-items-center'
          } `}
          id="successModal_regis"
          tabIndex="-1"
          role="dialog"
          aria-hidden="false"
        >
          <div
            ref={myRef}
            className="modal-dialog modal-sm !tw-w-[453px] !tw-h-min-[346px] !tw-top-0"
            role="document"
          >
            <div
              className="modal-content !tw-h-full"
              style={{ borderRadius: '20px' }}
            >
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModal(false);
                    dispatch({
                      type: HIT_BOARD_STATUS,
                      payload: {
                        status: '',
                        message: '',
                        listView: '',
                      },
                    });
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body !tw-gap-[45px] !tw-flex !tw-flex-col">
                <img
                  src={status === 'success' ? ImgSuccess : ImgFailed}
                  width={128}
                  height={128}
                  className="mx-auto"
                />
                {listView === 'listView' ? (
                  <div className="tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-1">
                    <Label typeLabel="f14w400">Import Failed</Label>
                    {/* <MessageTable data={tableMessage} message={message} /> */}
                    <span className="tw-mb-4">
                      Your import process gets error, please retry
                    </span>
                    {button && (
                      <ButtonCustom
                        className="!tw-p-[12px] !tw-w-[125px] !tw-flex !tw-justify-center tw-items-center"
                        func={() => {
                          setModalImport({
                            type: 'import-choose',
                            status: true,
                          });
                          dispatch({
                            type: HIT_BOARD_STATUS,
                            payload: {
                              status: '',
                              message: '',
                              listView: '',
                            },
                          });
                        }}
                      >
                        Re-Upload
                      </ButtonCustom>
                    )}
                  </div>
                ) : (
                  <p className="mb-0 msg mx-3">{message}</p>
                )}
              </div>
            </div>
          </div>
        </div>,
        document.getElementById('portal'),
      )}
    </>
  );
}

export default PopUp;
